export default __webpack_public_path__ + "static/media/projet-jolof-fond.fd137f67.webp";